var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit Icon",
    clipPath: "url(#clip0_569_1212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6853 1.69023C12.4008 1.40585 12.0151 1.24609 11.6129 1.24609C11.2107 1.24609 10.825 1.40585 10.5406 1.69023L9.87206 2.35871L12.0168 4.50343L12.6853 3.83494C12.9696 3.55051 13.1294 3.16478 13.1294 2.76258C13.1294 2.36038 12.9696 1.97465 12.6853 1.69023ZM11.4038 5.11645L9.25904 2.97174L2.23904 9.99174C1.88247 10.3481 1.62034 10.7878 1.47637 11.2709L1.01415 12.8223C0.991836 12.8971 0.990172 12.9766 1.00933 13.0524C1.0285 13.1281 1.06778 13.1972 1.12301 13.2525C1.17825 13.3077 1.24739 13.347 1.32312 13.3662C1.39885 13.3853 1.47836 13.3837 1.55322 13.3613L3.10455 12.8991C3.58771 12.7551 4.02736 12.493 4.38375 12.1364L11.4038 5.11645Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_569_1212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8667,
    height: 13.8667,
    fill: "white",
    transform: "translate(0.128906 0.378906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.f6fe7b3a97ed175ef37afdcb940e59c9.svg";
export { ForwardRef as ReactComponent };